/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const UploadReport = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 15 19">
      <g>
        <path d="M14,18 L1,18 L1,5 L4.5,5 C4.776,5 5,4.776 5,4.5 L5,1 L14,1 L14,18 Z M4,1.707 L4,4 L1.707,4 L4,1.707 Z M14.5,0 L4.5,0 C4.478,0 4.458,0.01 4.437,0.013 C4.414,0.016 4.395,0.02 4.373,0.025 C4.287,0.049 4.207,0.086 4.146,0.147 L0.147,4.146 C0.086,4.207 0.049,4.287 0.025,4.373 C0.02,4.395 0.016,4.413 0.013,4.436 C0.01,4.457 0,4.477 0,4.5 L0,18.5 C0,18.776 0.224,19 0.5,19 L14.5,19 C14.776,19 15,18.776 15,18.5 L15,0.5 C15,0.224 14.776,0 14.5,0 L14.5,0 Z" />
        <path d="M7.8545 9.0977C7.8075 9.0507 7.7515 9.0137 7.6915 8.9887 7.5685 8.9387 7.4315 8.9387 7.3085 8.9887 7.2485 9.0137 7.1925 9.0507 7.1455 9.0977L5.1465 11.0967C4.9515 11.2917 4.9515 11.6087 5.1465 11.8037 5.3415 11.9987 5.6585 11.9987 5.8535 11.8037L7.0005 10.6577 7.0005 15.4997C7.0005 15.7767 7.2235 15.9997 7.5005 15.9997 7.7765 15.9997 8.0005 15.7767 8.0005 15.4997L8.0005 10.6577 9.1465 11.8037C9.2445 11.9017 9.3725 11.9507 9.5005 11.9507 9.6275 11.9507 9.7555 11.9017 9.8535 11.8037 10.0485 11.6087 10.0485 11.2917 9.8535 11.0967L7.8545 9.0977zM4.5 7C4.224 7 4 7.224 4 7.5 4 7.776 4.224 8 4.5 8L10.5 8C10.776 8 11 7.776 11 7.5 11 7.224 10.776 7 10.5 7L4.5 7z" />
      </g>
    </BaseSvgIcon>
  )
}

export default UploadReport
